<template>
  <v-menu offset-y top :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch edit</v-btn>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateActive"/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="input.active" hide-detlails :disabled="!input.updateActive"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateReorderPoint" class="mt-0"/>
            </v-col>
            <v-col cols="6">
              <decimal-number-input label="Reorder point" v-model="input.reorderPoint" prefix="" suffix="LAA" :precision="3" no-minimum :disabled="!input.updateReorderPoint"/>
            </v-col>
          </v-row>
          <template v-if="connectedToAccounting && values">
            <v-row>
              <v-col cols="2">
                <v-simple-checkbox v-model="input.updateInventoryAccount" class="mt-2"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.inventoryAccountRef" label="Inventory asset account"
                                :disabled="!input.updateInventoryAccount"
                                :accounts="inventoryAccounts" :addTypes="['OtherCurrentAsset']" hint=""/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-simple-checkbox v-model="input.updateIncomeAccount" class="mt-2"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.incomeAccountRef" label="Income account"
                                :disabled="!input.updateIncomeAccount"
                                :accounts="incomeAccounts" :addTypes="['Income']" hint=""/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-simple-checkbox v-model="input.updateCogAccount" class="mt-2"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.cogAccountRef" label="Cost of goods account"
                                :disabled="!input.updateCogAccount"
                                :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']" hint=""/>
              </v-col>
            </v-row>
          </template>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'SpiritsBatchEdit',
  props: {
    spirits: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateActive: false,
              updateReorderPoint: false,
              updateInventoryAccount: false,
              updateIncomeAccount: false,
              updateCogAccount: false,
              active:true,
              reorderPoint: -1,
              inventoryAccountRef: '',
              incomeAccountRef: '',
              cogAccountRef: '',
              alcohols:[]},
      accounts: [],
      saving: false
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    inventoryAccounts() {
      return this.accounts.filter(account => account.type === 'OtherCurrentAsset');
    },
    incomeAccounts() {
      return this.accounts.filter(account => account.type === 'Income');
    },
    cogAccounts() {
      return this.accounts.filter(account => account.type === 'CostOfGoodsSold');
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  async created() {
    if (!this.connectedToAccounting)
      return;

    const results = await this.$apiCall(`query SpiritsBatchEdit($currency: String!) {
                                            companyAccounts {
                                              spiritInventory,spiritCOG,spiritIncome,
                                            }
                                            accounts(currency:$currency) {
                                              ref,name,type
                                            }
                                          }`,
                                        {currency:this.$store.getters.company.settings.homeCurrency});
    if (!results.error) {
      this.accounts = results.data.accounts;
      this.input.inventoryAccountRef = results.data.companyAccounts.spiritInventory;
      this.input.incomeAccountRef = results.data.companyAccounts.spiritIncome;
      this.input.cogAccountRef = results.data.companyAccounts.spiritCOG;
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.alcohols = this.spirits.map(spirit => spirit.id);
      const results = await this.$apiCall(`mutation SpiritsBatchEdit($input: AlcoholBatchUpdateInput!) {
                                              spiritsBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.spiritsBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.spirits.length - errorCount} of ${this.spirits.length} spirits\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.spiritsBatchUpdate);
      }
    }
  }
}
</script>